import isPropValid from '@emotion/is-prop-valid';

/**
 * getForwardProps
 *
 * takes component props and a styled-system utility function (which may be
 * composed from several styled-system utility functions). It returns the component props
 * that were not handled by the utility function and are valid for HTML and SVG elements.
 *
 * @param props - component props object
 * @param exclude - props to exclude
 */
function getForwardProps(props, exclude) {
    var forwardProps = {};
    Object.keys(props).forEach(function (prop) {
        if (!(exclude === null || exclude === void 0 ? void 0 : exclude.includes(prop)) && isPropValid(prop)) {
            forwardProps[prop] = props[prop];
        }
    });
    return forwardProps;
}

export { getForwardProps };
//# sourceMappingURL=getForwardProps.js.map
